module.exports = __webpack_public_path__ + "img/8固定原子20220420_101156.06a653f2.gif";